import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { ConfigService } from '@app/config.services';
import { WebStorageService } from './webstorage.service';
import { environment } from '@environments/environment';
import { LoaderService } from './loader.service';
import { catchError, map } from 'rxjs/operators';
import { Utils } from '@app/_core/helper/Utils';
import { SafeHtml } from '@angular/platform-browser';
export interface ChatMessage {
    role: 'user' | 'bot';
    text: string | SafeHtml;
    timestamp: Date;
    followUps?: string[];
}

@Injectable({
    providedIn: 'root'
})
export class ChatbotService {
    private apiBase: string = '';

    private _chatTitle$ = new BehaviorSubject<string>('AI Assistant');
    readonly chatTitle$ = this._chatTitle$.asObservable();

    private _openToTab$ = new BehaviorSubject<'transcript' | 'ai-suggestion' | null>(null);
    readonly openToTab$ = this._openToTab$.asObservable();

    openTab(tab: 'transcript' | 'ai-suggestion'): void {
        this._openToTab$.next(tab);
    }

    setChatTitle(userName: string): void {
        this._chatTitle$.next(userName ? `Call with ${userName}` : 'AI Assistant');
    }

    constructor(private http: HttpClient, private configService: ConfigService,
        private loaderService: LoaderService,
        private webStorageService: WebStorageService
    ) {
        this.apiBase = this.configService.getConfig()?.apiUrl ?? '';
    }

    sendMessage(userText: string, history: ChatMessage[]): Observable<string> {
        // Stub: replace with real GenAI API endpoint when available
        // Example hookup:
        // return this.http.post<{ response: string }>(`${this.apiBase}/api/GenAI/Chat`, { message: userText })
        //     .pipe(map(res => res.response), catchError(() => of('Sorry, I could not process your request.')));

        //const mockReplies: string[] = [
        //    'How can I help you further?',
        //    'I understand. Let me look into that for you.',
        //    'Sure! Could you provide more details?',
        //    'Thank you for reaching out. I\'m here to assist.',
        //    'I\'ll get that information for you shortly.'
        //];
        //const reply = mockReplies[Math.floor(Math.random() * mockReplies.length)];
        //return of(reply);
        

        const pl: any = {
            botQuestion: userText
            

        };
        const user = this.webStorageService.getItemFromSessionStorage('currentUser');
        const company = this.webStorageService.getItemFromSessionStorage('company');
        pl.user = user;
        pl.company = company;

        // this.loaderService.display(true);
        return this.http.post<any>(`${environment.apiUrl}api/service/data/SearchKnowledgeBase`, pl).pipe(
            map(res => {
                this.loaderService.display(false);
                // console.log(res);
                return res;
            }),
            catchError(Utils.handleHttpError)
        );
    }
}
